import { createFileRoute } from '@tanstack/react-router'
import { Work } from '@thom/folio-ui/pages/work'

export const Route = createFileRoute('/_authenticated/$client/$domain/$slug/work')({
	component: Work,
})
